import { DEFAULT_SPONSORSHIP_AMOUNT_PLS } from '@bridge-sponsor/types'

export const SPONSORSHIP_AMOUNT_PLS = DEFAULT_SPONSORSHIP_AMOUNT_PLS
export const SPONSORSHIP_AMOUNT_DISPLAY = Number(SPONSORSHIP_AMOUNT_PLS / 10n ** 18n)
export const AVG_GAS_PLS = 5n * 10n ** 18n
